export default __webpack_public_path__ + "static/media/adamCollier.4271be2a.png";